import {Department} from '../../models/middleware';
import {OrderLine, OrderLineSticker} from '../../transport/apiServiceResponse';

// Web only
export const isBeerBoardUrl = () =>
  window?.location?.href?.includes('beer-board');

export const isBeerDepartment = (department: Department) =>
  department.name === 'Beer';

export const isBeerCase = (product: OrderLine) => product.size?.quantity >= 16;

export const isSavingOrSpecialSticker = (sticker: OrderLineSticker) =>
  sticker?.saving || sticker?.special;

export const isSavingsOrSpecial = (product: OrderLine) =>
  product?.stickers?.some(isSavingOrSpecialSticker);
